<span class="offer-page-tag" *ngIf="actionLog">
  <span *ngIf="!contract_established_or_cancel() else ContractEstablishedOrCancelContent">
    <!-- 未連絡 -->
    <span *ngIf="
        offerService.isWaitingQuery(matchingOffer, mailType) && actionLog.user_id
      ">&nbsp;by&nbsp;{{ actionLog.user_id }}
      &nbsp;&nbsp;{{matchingOffer.created_at | date: 'yy-MM-dd HH:mm'}}</span>
    <!-- 回答待ち -->
    <span *ngIf="
        offerService.isChecking(matchingOffer, mailType) && showConfirmUserId()
      ">&nbsp;by&nbsp;{{ showConfirmUserId() }}&nbsp;&nbsp;{{actionLogTime('mail_confirm') | date: 'yy-MM-dd HH:mm'}}</span>
    <!-- 承諾 -->
    <span *ngIf="
        offerService.isApproved(matchingOffer, mailType) && showApproveUserId()
      ">&nbsp;by&nbsp;{{ showApproveUserId() }} &nbsp;&nbsp;{{actionLogTime('approve') | date: 'yy-MM-dd HH:mm'}}</span>
    <!-- 辞退 -->
    <span *ngIf="
        offerService.isRejected(matchingOffer, mailType) && showApproveUserId()
      ">&nbsp;by&nbsp;{{ showApproveUserId() }}</span>
    <!-- 面談中 -->
    <span
      *ngIf="offerService.isInterviewing(matchingOffer) && showApproveUserId()">&nbsp;by&nbsp;{{ showApproveUserId() }}
      {{actionLogTime('interviewing') | date: 'yy-MM-dd HH:mm'}}
    </span>
  </span>
  
  <!-- 成立・不成立・取消を実行したユーザーを最終更新者としてメールアドレス・変更日時を表示する -->
  <ng-template #ContractEstablishedOrCancelContent>
    <!-- 成立 -->
    <span *ngIf="
      offerService.isSucceeded(matchingOffer) &&
      actionLog.contract_established_user_id
    ">&nbsp;by&nbsp;{{ actionLog.contract_established_user_id }} &nbsp;&nbsp;{{actionLogTime('contract_established') | date: 'yy-MM-dd HH:mm'}}</span>
    <!-- 不成立 -->
    <span *ngIf="
      offerService.isFailed(matchingOffer) &&
      actionLog.contract_established_user_id
    ">&nbsp;by&nbsp;{{ actionLog.contract_established_user_id }} &nbsp;&nbsp;{{actionLogTime('contract_established') | date: 'yy-MM-dd HH:mm'}}</span>
    <!-- 取消 -->
    <span *ngIf="
        offerService.isCancelled(matchingOffer) && actionLog.cancel_user_id
      ">&nbsp;by&nbsp;{{ actionLog.cancel_user_id }} &nbsp;&nbsp;{{actionLogTime('cancel') | date: 'yy-MM-dd HH:mm'}}</span>
  </ng-template>
</span>
